<div class="container">
  <mat-icon
    class="filter-top-btn"
    (click)="isFilterOpen = true"
    matTooltip="Table Filter"
  >
    filter_list
  </mat-icon>
   <p class="title">
   Sailing Performance 
    <mat-icon class="titleIcon">chevron_right</mat-icon> Commercial Performance<mat-icon class="titleIcon">chevron_right</mat-icon> Charter Party Performance<mat-icon class="titleIcon">chevron_right</mat-icon> Vessel View
  </p>

  <div class="filter-container" [class.open]="isFilterOpen">
    <div class="filter-panel dark-filter">
      <!-- HEADER -->
      <div class="filter-header">
        <div class="header-left">
          <mat-icon>filter_alt</mat-icon>
          <span>Table Filter</span>
        </div>
        <mat-icon class="close-btn" (click)="isFilterOpen = false">close</mat-icon>
      </div>

      <!-- BODY -->
      <form [formGroup]="filterForm" class="filter-body">
        <div class="filter-grid">
          <app-custom-date-picker
            [label]="'From Date:'"
            [controlname]="filterForm.controls['from_date']"
          ></app-custom-date-picker>

          <app-custom-date-picker
            [label]="'To Date:'"
            [controlname]="filterForm.controls['to_date']"
          ></app-custom-date-picker>

          <app-custom-dropdown
            [placeholder]="'ALL'"
            [label]="'Condition:'"
            [items]="conditionOptions"
            [controlname]="filterForm.controls['condition']"
          ></app-custom-dropdown>

          <app-custom-input
            placeholder="Voyage Number"
            label="Voyage Number :"
            [controlname]="filterForm.controls['voyNumber']"
          ></app-custom-input>
        </div>
      </form>

      <!-- FOOTER -->
      <div class="filter-footer">
        <button type="button" class="btn clear-btn" (click)="clearClick()">
          <mat-icon>clear_all</mat-icon>
          Clear Filter
        </button>

        <button type="button" class="btn apply-btn" (click)="filterClick()">
          <mat-icon>filter_list</mat-icon>
          Apply Filter
        </button>
      </div>
    </div>
  </div>


  <!-- <div class="text-right top">
    <button class="btn btn-light hover-button mail" >
    Periodic report
    </button>
  </div> -->

  <h2 class="tableTitle" [ngClass]="{ 'dark-tableTitle': isDarkMode() }">
    Vessel View Table
  </h2>
  <div class="table-container scroll-bar">
    <!-- <br> -->
    <!-- <div class="toggle">
      <mat-slide-toggle (change)="toggleMapView()">
        {{ graph ? "Table View" : "Graphical Representation" }}
      </mat-slide-toggle>
    </div> -->

    <table
      class="mat-elevation-z8"
      id="style-4"
      matSort
      [ngClass]="{ 'dark-table': isDarkMode() }"
    >
      <thead class="sticky-header">
        <tr>
          <th class="th-text-center2" mat-sort-header="sNo" rowspan="2">
            S.No
          </th>
          <th
            class="fixed-head th-text-center3"
            mat-sort-header="shipName"
            rowspan="2"
            *ngIf="subusername !== 'demo'"
          >
            Ship
          </th>
          <th class="th-text-center3" rowspan="2" mat-sort-header="imoNumber" *ngIf="subusername !== 'demo'">
            I.M.O Number
          </th>
          <th class="th-text-center" mat-sort-header="segment" rowspan="2">
            Segment
          </th>
          <th class="th-text-center" mat-sort-header="voyNumber" rowspan="2">
            Voy Number
          </th>
          <th class="th-text-center" mat-sort-header="condition" rowspan="2">
            Condition
          </th>
          <th colspan="4">Ports</th>
          <th rowspan="2">Instructed Speed <br />(kts)</th>
          <th rowspan="2">CP Consumption <br />(mt/day)</th>
          <th rowspan="2">Good Wx<br />Performance Speed <br />(kts)</th>
          <th rowspan="2">Voyage<br />Average Speed <br />(kts)</th>
          <th colspan="3">Good Wx Consumption (Mt)</th>
          <th rowspan="2">Good Wx %</th>
          <th rowspan="2">Good Wx Dist <br />(nm)</th>
          <th rowspan="2">Voyage Duration <br />(Hours)</th>
          <th rowspan="2">Voyage Distance <br />(nm)</th>
          <th rowspan="2">Total Bunker Consumption (Mt) <br /></th>
          <th rowspan="2">Average Daily Consumption <br />(mt/day)</th>
          <th class="th-text-center2" mat-sort-header="timeLost" rowspan="2">
            <span class="info">
              Time(Hrs)<mat-icon
                class="info"
                matTooltip="loss in red gain in green"
                >info</mat-icon
              ><br />
              Lost(-) or Gained(+)</span
            >
          </th>
          <th colspan="3">
            <span class="header-show info1">
              Bunker Lost(-) or Gained(mt)<mat-icon
                class="info"
                matTooltip="loss in red gain in green"
                >info</mat-icon
              >
            </span>
          </th>
          <th colspan="2">
            <span class="info2"
              >Claim Estimate
              <mat-icon
                class="info"
                matTooltip="Enter both Daily Hire and Avg Bunker Price to see the Claimable Amount and Save"
                >info</mat-icon
              ></span
            >
          </th>
          <th rowspan="2">
            <span class="header-show info1">
              Claimable Amout($)<mat-icon
                class="info"
                matTooltip="Negative Shows Under Performance Positive Shows Over Performance"
                >info</mat-icon
              >
            </span>
          </th>
          <th rowspan="2" *ngIf="username !== 'Zeronorth ZN'">Remarks <br />See / Add</th>
          <th rowspan="2">
            <span class="info2">Claimable</span>
          </th>

          <th rowspan="2">
            <span class="info2">Report</span>
          </th>
          <!-- <th rowspan="2">
            <span class="info2"
              >Graphical Represntation(Voyage)</span
            >
          </th> -->
        </tr>
        <tr>
          <th><span>From</span></th>
          <th><span>To</span></th>
          <th>
            <span>COSP <br />(Date & UTC time)</span>
          </th>
          <th>
            <span>EOSP <br />(Date & UTC time)</span>
          </th>
          <th><span>HSFO</span></th>
          <th><span>VLSFO</span></th>
          <th><span>GO</span></th>
          <th mat-sort-header="hsfo"><span>HSFO</span></th>
          <th mat-sort-header="vlsfo"><span>VLSFO</span></th>
          <th mat-sort-header="go"><span>GO</span></th>
          <th><span>Daily Hire($) </span></th>
          <th><span>Avg Bunker Price(MT)</span></th>
        </tr>
      </thead>
      <tbody>

        <ng-container *ngIf="isLoadingTable">
    <tr *ngFor="let row of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]">
      <td><div class="skeleton skeleton-text short"></div></td>
      <td class="fixed-col" *ngIf="subusername !== 'demo'">
        <div class="skeleton skeleton-text"></div>
      </td>
      <td *ngIf="subusername !== 'demo'"><div class="skeleton skeleton-text"></div></td>
      <td><div class="skeleton skeleton-badge"></div></td>
      <td><div class="skeleton skeleton-text short"></div></td>
      <td><div class="skeleton skeleton-text short"></div></td>
      <td><div class="skeleton skeleton-text"></div></td>
      <td><div class="skeleton skeleton-text"></div></td>
      <td><div class="skeleton skeleton-text"></div></td>
      <td><div class="skeleton skeleton-text"></div></td>
      <td><div class="skeleton skeleton-text short"></div></td>
      <td><div class="skeleton skeleton-text short"></div></td>
      <td><div class="skeleton skeleton-text short"></div></td>
      <td><div class="skeleton skeleton-text short"></div></td>
      <td><div class="skeleton skeleton-text short"></div></td>
      <td><div class="skeleton skeleton-text short"></div></td>
      <td><div class="skeleton skeleton-text short"></div></td>
      <td><div class="skeleton skeleton-text short"></div></td>
      <td><div class="skeleton skeleton-text short"></div></td>
      <td><div class="skeleton skeleton-text short"></div></td>
      <td><div class="skeleton skeleton-text short"></div></td>
      <td><div class="skeleton skeleton-text short"></div></td>
      <td><div class="skeleton skeleton-text short"></div></td>
      <td><div class="skeleton skeleton-text short"></div></td>
      <td><div class="skeleton skeleton-text short"></div></td>
      <td><div class="skeleton skeleton-text short"></div></td>
      <td><div class="skeleton skeleton-text short"></div></td>
      <td><div class="skeleton skeleton-text short"></div></td>
      <td><div class="skeleton skeleton-text short"></div></td>
      <td><div class="skeleton skeleton-text short"></div></td>
      <td *ngIf="username !== 'Zeronorth ZN'"><div class="skeleton skeleton-btn"></div></td>
      <td><div class="skeleton skeleton-text short"></div></td>
      <td><div class="skeleton skeleton-btn"></div></td>
    </tr>
  </ng-container>
  <ng-container *ngIf="!isLoadingTable">
         <tr *ngFor="let element of elements; let rowIndex = index">
          <td>{{ element.sNo }}</td>
          <td
            class="fixed-col"
            [ngStyle]="{ color: getVesselNameColor(element.timeLost) }"
            *ngIf="subusername !== 'demo'"
          >
            {{ element.shipName }}
          </td>
          <td *ngIf="subusername !== 'demo'">{{ element.imoNumber }}</td>
          <td>{{ element.segment }}</td>
          <td>{{ element.voyNumber }}</td>
          <td>{{ element.condition }}</td>
          <td>{{ element.from }}</td>
          <td>{{ element.to }}</td>
          <td>{{ element.fromDate }}</td>
          <td>{{ element.toDate }}</td>
          <td>{{ element.instructedSpd }}</td>
          <td>{{ element.cpConsumption }}</td>
          <td>{{ element.goodWxPerSpd }}</td>
          <td>{{ element.voyAvgSpd }}</td>
          <td>{{ element.goodWxDailyConsp.HSFO }}</td>
          <td>{{ element.goodWxDailyConsp.VLSFO }}</td>
          <td>{{ element.goodWxDailyConsp.GO }}</td>
          <td>{{ element.goodWxPer + "%" }}</td>
          <td>{{ element.goodWxDist }}</td>
          <td>{{ element.voyDuration }}</td>
          <td>{{ element.voyDistance }}</td>
          <td>{{ element.totalBunkerConsumption }}</td>
          <td>{{ element.averageDialyCon }}</td>
          <td
            [ngStyle]="{
              'color':
                element.timeLost < 0
                  ? '#ff9090'
                  : element.timeLost > 0
                  ? '#a8d296'
                  : 'inherit',
                  
            }"
          >
            {{ element.timeLost }}
          </td>
          <td
            [ngStyle]="{
              'color':
                element.bunkerLostOrGain.HSFO < 0
                  ? '#ff9090'
                  : element.bunkerLostOrGain.HSFO > 0
                  ? '#a8d296'
                  : 'inherit',
                  
            }"
          >
            {{ element.bunkerLostOrGain.HSFO }}
          </td>
          <td
            [ngStyle]="{
              'color':
                element.bunkerLostOrGain.VLSFO < 0
                  ? '#ff9090'
                  : element.bunkerLostOrGain.VLSFO > 0
                  ? '#a8d296'
                  : 'inherit',
                  
            }"
          >
            {{ element.bunkerLostOrGain.VLSFO }}
          </td>
          <td
            [ngStyle]="{
              'color':
                element.bunkerLostOrGain.GO < 0
                  ? '#ff9090'
                  : element.bunkerLostOrGain.GO > 0
                  ? '#a8d296'
                  : 'inherit',
                  
            }"
          >
            {{ element.bunkerLostOrGain.GO }}
          </td>
          <td>
            <ng-container
              *ngIf="
                editedRowIndex !== rowIndex || editedColumnName !== 'dailyHire'
              "
            >
              {{ element.claimEst.hire }}
              <button class="downloadIcon" (click)="editCell(rowIndex, 'dailyHire')">
                <mat-icon class="edit">edit</mat-icon>
              </button>
            </ng-container>
            <ng-container
              *ngIf="
                editedRowIndex === rowIndex && editedColumnName === 'dailyHire'
              "
            >
              <input
                type="number"
                [(ngModel)]="element.claimEst.hire"
                (focusout)="exitEdit(element)"
              />
            </ng-container>
          </td>
          <td>
            <ng-container
              *ngIf="
                editedRowIndex !== rowIndex ||
                editedColumnName !== 'avgBunkerPrice'
              "
            >
              {{ element.claimEst.bunkPrice }}
              <button
              class="downloadIcon"
                (click)="editCell(rowIndex, 'avgBunkerPrice')"
              >
                <mat-icon class="edit">edit</mat-icon>
              </button>
            </ng-container>
            <ng-container
              *ngIf="
                editedRowIndex === rowIndex &&
                editedColumnName === 'avgBunkerPrice'
              "
            >
              <input
                type="number"
                [(ngModel)]="element.claimEst.bunkPrice"
                (focusout)="exitEdit(element)"
              />
            </ng-container>
          </td>
          <td>
            {{ calculateClaimableAmount(element) }}
          </td>
          <td *ngIf="username !== 'Zeronorth ZN'">
            <button
              mat-icon-button
              (click)="openRemarks(element)"
              [matTooltip]="getFirstCommentTooltip(element.voyag_id)"
              matTooltipPosition="above"
            >
              <mat-icon>visibility</mat-icon>
            </button>
          </td>
          <td>
            {{ element.claimable }}
          </td>
          <td>
            <button class="downloadIcon" (click)="downloadIcon(element)" [disabled]="subusername === 'demo'">
              <mat-icon  >download</mat-icon>
            </button>
          </td>

          <!-- Other row data cells go here -->
        </tr>
  </ng-container>
   
      </tbody>
    </table>
  </div>
  <mat-paginator
    [length]="length"
    [pageSizeOptions]="[]"
    [pageSize]="itemsPerPage"
    (page)="onPageChange($event)"
    [hidePageSize]="true"
    showFirstLastButtons
    [ngClass]="{ 'dark-paginator': isDarkMode() }"
  ></mat-paginator>
  <br />
  <div class="text-right">
    <button
      class="btn btn-light hover-button mail"
      *ngIf="save"
      (click)="saveClick()"
    >
      <mat-icon>save</mat-icon>&nbsp;Save
    </button>
    <button class="btn btn-light hover-button back" (click)="backClick()">
      <mat-icon>keyboard_backspace</mat-icon>&nbsp; Back To Fleet View
    </button>
    <!-- <button class="btn btn-light hover-button mail" (click)="downloadClick()">
      <mat-icon>download</mat-icon>&nbsp; Download
    </button> -->
    <button class="btn btn-light hover-button mail" (click)="printTable()">
      <mat-icon>print</mat-icon>&nbsp; Print
    </button>
    <button class="btn btn-light hover-button mail" (click)="exportClick()">
      <mat-icon>download</mat-icon>&nbsp; Export
    </button>
  </div>
  <br />
</div>
